module.exports = __webpack_public_path__ + "star-twilight-neon.b7f048ab9e573e0c7d54.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-twilight-neon.svg
// module id = ../../../../../src/assets/img/star-twilight-neon.svg
// module chunks = main